import { HttpContextToken } from '@angular/common/http';

export const SKIP_OFFLINE_INTERCEPTOR = new HttpContextToken<boolean>(() => false);
